<template>
  <v-dialog v-model="login.open" width="500px" persistent>
    <v-card>
      <v-card-title class="grey lighten-4 py-4 title">
        Ingresar
      </v-card-title>
      <v-container grid-list-sm class="pa-4">
        <v-layout row wrap>
          <div class="red--text">{{ msgError }} {{ mensaje }}</div>
          <v-flex xs12 align-center justify-space-between>
            <v-layout align-center>
              <v-text-field label="Usuario" v-model="usuario" type="text"></v-text-field>
            </v-layout>
          </v-flex>
          <v-flex xs12 align-center justify-space-between>
            <v-layout align-center>
              <v-text-field v-on:keyup.enter="loginIngresar" label="Clave" v-model="clave" type="password"></v-text-field>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="loginIngresar">Ingresar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'login',
  props: ['login', 'msgError'],
  data: () => ({
    usuario: '',
    clave: '',
    mensaje: ''
  }),
  methods: {
    cambiarMensaje: function (mensaje) {
      this.mensaje = mensaje
    },
    cerrarVentana: function () {
      this.login.open = false
    },
    loginIngresar: function () {
      const myRequest = new Request(`${process.env.LOGIN}`, {method: 'POST', body: `d=${JSON.stringify({usuario: this.usuario, clave: this.clave})}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.cambiarMensaje(datos.m)
          } else {
            this.cerrarVentana()
            this.$emit('set-token', datos.d)
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login.vue